import { helper } from '@ember/component/helper';
import { isArray as isEmberArray } from '@ember/array';
import { isEqual } from '@ember/utils';

export function emberPowerSelectIsEqual(
  [option, selected]: [any, any] /* , hash*/,
): boolean {
  if (selected === undefined || selected === null) {
    return false;
  }
  if (isEmberArray(selected)) {
    for (let i = 0; i < selected.length; i++) {
      if (isEqual(selected[i], option)) {
        return true;
      }
    }
    return false;
  } else {
    return isEqual(option, selected);
  }
}

export default helper(emberPowerSelectIsEqual);
